<section class="pb-3 pb-lg-8">
  <div class="row">
    <div class="col-12">
      <ng-container>
        <div class="card min-h-350px">
          @if(isLoading()){
          <app-skeleton-order-detail></app-skeleton-order-detail>
          }@else if (notFound()) {
          <div class="card-body">
            <div class="empty-state" data-testid="order-not-found">
              <span class="empty-state__mark">
                <app-keenicon name="handcart" class="fs-2tx"></app-keenicon>
              </span>
              <p class="empty-state__title">{{ "APP.ORDER_NOT_FOUND" | translate }}</p>
              <p class="empty-state__body">{{ "APP.ORDER_NOT_FOUND_HINT" | translate }}</p>
              <a class="btn btn-primary" routerLink="/purchase-order">{{ "USER_MENU.PURCHASE_ORDER" | translate }}</a>
            </div>
          </div>
          }@else {
          <!-- The demo runs the whole checkout so people can see it, but there
               is no payment provider behind it and the seeded bank accounts are
               fictional. Saying so is the honest thing and it is also what stops
               anyone trying to transfer real money. -->
          @if (demo.enabled && demo.paymentIsSimulated) {
          <div class="alert alert-warning d-flex align-items-center mx-5 mt-5 mb-0" data-testid="simulated-notice">
            <span class="fs-7">
              ระบบสาธิต — เลขบัญชีที่แสดงเป็นข้อมูลตัวอย่าง ไม่ต้องโอนเงินจริง
              คุณกดแจ้งชำระเงินเพื่อดูขั้นตอนได้ตามปกติ
            </span>
          </div>
          }
          <div class="card-header align-items-center gap-2 gap-md-0 justify-content-start py-5 text-gray-700">
            <div class="d-lg-none w-100 ms-n2 mb-2">
              <app-breadcrumb-custom type="bc"
                [title]="`รายละเอียดคำสั่งซื้อ : ${transaction_info.code}`"></app-breadcrumb-custom>
            </div>

            <p class="fs-5 mb-0 pe-sm-4 w-100 w-sm-auto">
              {{ "APP.MY_ORDER" | translate }}:
              <span class="text-gray-800 fw-bold">{{
                transaction_info.code
                }}</span>
            </p>
            <p class="fs-5 mb-0 w-100 w-sm-auto border-start border-end bordermax-sm-none px-sm-4 me-sm-4">
              {{ "APP.ORDER_DATE" | translate }}:
              <span class="text-gray-800 fw-bold">
                <!-- BE, like every other date in the build. Angular's plain
                     `date` pipe printed the Gregorian year here while the list
                     this page is opened from printed the Buddhist one. -->
                {{
                transaction_info.created_at | bEDate : "dd/MM/yyyy HH:mm"
                }}</span>
            </p>

            <div class="badge p-3 px-4 fs-6 fw-semibold order-2 order-sm-1" [ngClass]="{
              'badge-light-info' : transaction_info.transaction_status_id === 1,
              'badge-light-warning' : transaction_info.transaction_status_id === 2,
              'badge-light-success' : transaction_info.transaction_status_id === 3,
              'badge-light-danger' : transaction_info.transaction_status_id === 4,
            }">
              {{ transaction_info.transaction_status_name }}
            </div>
            <!-- The whole tracking row, not just its value, is conditional.
                 Every course here is a download, so on this build the row could
                 only ever read "หมายเลข Tracking : —" — furniture describing a
                 delivery that does not exist. The list view drops its two
                 tracking columns on the same test. (It once printed the literal
                 "EV12132133" on every order, linked to Thailand Post, as if it
                 were real.) -->
            @if (transaction_info.tracking_no) {
            <div
              class="d-flex w-100 w-sm-auto flex-fill flex-start flex-md-end align-items-center gap-3 order-1 order-sm-2">
              <p class="text-gray-800 fs-6 mb-0">
                หมายเลข Tracking :
                <a [attr.href]="'https://track.thailandpost.com/'"
                  class="text-gray-800 text-hover-primary text-hover-underline" target="_blank">{{
                  transaction_info.tracking_no }}</a>
              </p>
              <button class="btn btn-sm btn-icon btn-light-primary order-action h-30px w-30px"
                [attr.aria-label]="'APP.ORDER_COPY_TRACKING' | translate"
                [attr.title]="'APP.ORDER_COPY_TRACKING' | translate">
                <app-keenicon name="copy" class="svg svg-icon fs-5"></app-keenicon>
              </button>
            </div>
            }
          </div>
          <div class="card-body d-flex p-0" [formGroup]="form">
            <div class="col-12 d-flex flex-column flex-lg-row flex-1">
              <div class="col-12 col-lg-4 order-2 order-lg-1 p-9 border-end">
                <app-transaction-summary [transaction_info]="transaction_info" [bankAcc]="bankAcc" [form]="form"
                  (onCancel)="cancelOrder()" (onSubmit)="submitPayment()"></app-transaction-summary>
              </div>
              <div class="col-12 col-lg-8 order-1 order-lg-2 p-9 border-bottom border-lg-none">
                <h4 class="mb-8">{{ "APP.ORDER_ITEM" | translate }}</h4>
                <div>
                  @for (course_item of transaction_info?.course_list; track
                  $index) {
                  <div
                    class="d-flex flex-column flex-sm-row align-items-center align-items-stretch justify-content-between mb-4 gap-4">
                    <img [src]="
                        course_item.course_image_url
                          ? fileUrl + course_item.course_image_url
                          : ''
                      " class="w-125px h-125px object-fit-cover rounded" />
                    <div class="d-flex flex-row flex-grow-1 align-items-center">
                      <div class="flex-grow-1 d-flex flex-row justify-content-between">
                        <div class="flex-grow-1">
                          <p
                            class="fw-bolder text-gray-800 text-hover-primary fs-5 mb-0 product-name text-overflow-line-1">
                            {{ course_item?.course_name }}
                          </p>
                          <p class="text-muted fw-semibold mb-4 fs-6">
                            {{
                            course_item?.course_tutors[0]?.tutor_name || ""
                            }}
                          </p>
                          <p class="text-gray-700 fw-bold mb-0 fs-6">
                            {{
                            (course_item?.course_price | currency : "฿") || ""
                            }}
                          </p>
                        </div>

                        <div class="d-flex flex-column justify-content-between text-end ps-4">
                          <p class="d-md-block fw-semibold fs-5 mb-0">
                            {{ "APP.AMOUNT" | translate }}
                          </p>
                          <p class="d-md-block fs-5 fw-semibold mb-0">
                            {{ course_item?.amount }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  @if($index !== transaction_info.course_list.length-1){
                  <div class="separator my-8"></div>
                  } }
                </div>
              </div>
            </div>
          </div>
          }
        </div>
      </ng-container>
    </div>
  </div>
</section>